import React from 'react';
import useInternalCoverBlob from '@/components/calendar/useInternalCoverBlob';
import { getInitials } from '@/lib/utils';

/**
 * Phase 27.39 — Shared avatar for non-agent users (Team page + sidebar,
 * dropdowns, etc.). Auth-safe photo blob + initials fallback. Mirrors
 * AgentAvatar so the visual language is consistent across the app.
 */
export function UserAvatar({
  user,
  size = 'w-9 h-9',
  rounded = 'full',
  textSize = 'text-xs',
  className = '',
  testId = 'user-avatar',
}) {
  const photoUrl = user?.photo_url || null;
  const blobUrl = useInternalCoverBlob(photoUrl);
  const displayName = user?.display_name || user?.name || user?.email || '';
  const initials = getInitials(displayName);
  const roundedCls = rounded === 'lg' ? 'rounded-lg' : 'rounded-full';

  if (blobUrl) {
    return (
      <div
        className={`${size} ${roundedCls} overflow-hidden flex-shrink-0 border border-slate-200 bg-white ${className}`}
        data-testid={`${testId}-photo`}
        title={displayName}
      >
        <img
          src={blobUrl}
          alt={displayName || 'User'}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      className={`${size} ${roundedCls} flex items-center justify-center text-white font-semibold flex-shrink-0 ${textSize} ${className}`}
      style={{ background: 'linear-gradient(135deg, var(--kr-navy-700), var(--kr-navy-900))' }}
      data-testid={`${testId}-initials`}
      title={displayName}
    >
      {initials}
    </div>
  );
}

export default UserAvatar;
